import type { CSSProperties } from 'react';
import {
  RARITY_BD_A,
  RARITY_COLOR,
  RARITY_LABEL,
  RARITY_LABEL_M,
  RARITY_TEXT_DARK,
  RARITY_TEXT_LIGHT,
  RARITY_TINT_A,
  rarityTint,
} from '../cosmetics/cosmeticsMap';

/** Бейдж редкости (шкала C): ромбы 1–4 + название; compact — только ромбы.
 *  По макету: tint-фон, обводка с альфой ступени, текст текстовым цветом
 *  редкости (светлая тема — через CSS-переменную). male — мужской род
 *  («Эпический» о предмете). Редкость всегда дублируется ромбами. */
export function RarityBadge({
  rarity,
  compact = false,
  male = false,
}: {
  rarity: number;
  compact?: boolean;
  male?: boolean;
}) {
  const color = RARITY_COLOR[rarity] ?? RARITY_COLOR[0];
  const diamonds = (
    <span className="bp-diamonds" aria-hidden>
      {Array.from({ length: rarity + 1 }, (_, i) => (
        <i key={i} style={{ background: color }} />
      ))}
    </span>
  );
  if (compact) return diamonds;
  const style = {
    background: rarityTint(rarity, RARITY_TINT_A[rarity] ?? 0.14),
    borderColor: rarityTint(rarity, RARITY_BD_A[rarity] ?? 0.5),
    '--rb-dark': RARITY_TEXT_DARK[rarity],
    '--rb-light': RARITY_TEXT_LIGHT[rarity],
  } as CSSProperties;
  return (
    <span className="bp-rarity" style={style}>
      {diamonds}
      {(male ? RARITY_LABEL_M : RARITY_LABEL)[rarity]}
    </span>
  );
}
